// Ajax 验签封装
import { hex_md5 } from '@/util/md5' 
import Cookies from 'js-cookie'
var secret="ff9ad7d6d2593a858efa4b3217b107eb";
export function objKeySort(obj) {//排序的函数
    var keys=[];
    for(var key in obj){
        if(obj[key]!=0&&!(obj[key]||obj[key]!=null)){
            obj[key]='';
        }
        keys.push(key);
    }
    var newkey = keys.sort();
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var newObj = {};//创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
    }
    var p=[];
    for(var key in newObj){
        p.push(key+"="+newObj[key]);
    }

    var time=new Date().getTime();
    var sign="";
    var token = sessionStorage.getItem('access_token');
    if(p.length>0){
        var str=p.join("&");
        sign="Token="+token+"&Topconn-Timestamp="+time+"&"+str+secret;
    }else{
        sign="Token="+token+"&Topconn-Timestamp="+time+secret;
    }
    console.log("签名前："+sign);
    newObj["Token"]=token;
    newObj["Topconn-Timestamp"]=time;
    newObj["sign"]=hex_md5(sign);
    //console.dir("签名后："+hex_md5(sign));
    return newObj;
}
